import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import classNames from './urgentBadge.module.css';

interface UrgentBadgeProps {
  /*
        What direction should the badge "float" to?
    */
  align: 'left' | 'right';
}

export function UrgentBadge({ align }: UrgentBadgeProps) {
  const isAlignRight = align === 'right';

  return (
    <View className={[classNames.urgentBadge, isAlignRight && classNames.alignRight]}>
      <MBIconV2 name="clock" size={grid(2)} />
      <Text size="caption1">{i18n('chat.urgent.label')}</Text>
    </View>
  );
}
